export const LOCALES = {
    ENGLISH: 'en-us',
    ARABIC: 'ar-sa',
    HEBREW: 'he',
};

//use component called : npm add react-intl